// src/components/SvgIcon/index.vue
<template>
  <svg :class="svgClass" >
    <use style="width: 100%;height:100%;" :xlink:href="iconName" />
  </svg>
</template>
<script>
export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`
    },
    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    }
  }
}
</script>
<style scoped>
/* 喜欢什么样式自己加，别客气 */
.svg-icon {
  /* width: 30px;
  height: 30px; */
  /* width: 1em;
  height: 1em; */
  /* vertical-align: -0.15em; */
  fill: currentColor !important;
  overflow: hidden;
  color: var(--main-bg-color) !important;
}
</style>
